import { Drawer } from '@/components';
import type {
  RelatedMaterialFormSchema,
  RelatedMaterialModel,
} from '@/features/project/projects/_models/related-material';
import { type FC, useMemo } from 'react';
import type { z } from 'zod';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { RelatedMaterialForm } from './RelatedMaterialForm';

type Props = {
  projectId: string;
  relatedMaterial: z.infer<typeof RelatedMaterialModel> | undefined;
  onSubmitRelatedMaterial: ({
    values,
    file,
  }: {
    values: z.infer<typeof RelatedMaterialFormSchema>;
    file: File | null;
  }) => void;
};

export const RelatedMaterialFormDrawer: FC<Props> = ({
  projectId,
  relatedMaterial,
  onSubmitRelatedMaterial,
}) => {
  const { drawerState, setDrawerState } = useProjectDetailDrawerState();

  const initialValues = useMemo(
    () => ({
      projectId,
      attachments: relatedMaterial?.attachments ?? [],
      additionalExplanation: relatedMaterial?.additionalExplanation,
    }),
    [relatedMaterial, projectId],
  );

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'related-material'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <RelatedMaterialForm
        initialValues={initialValues}
        onSubmit={onSubmitRelatedMaterial}
      />
    </Drawer>
  );
};
